import { Box, Stack, Typography } from '@mui/material';
import { ColDef } from '@siloreal:modules:private/silobag-list/config/extra/types';
import * as HOOKS from '@siloreal:shared:hooks';

const FALLBACK_STRING = '—';

export function buildProductColumn(): ColDef {
  return {
    field: 'silobag_product_type_id',
    headerName: HOOKS.useLocale.getState().t('temp.common.product'),
    minWidth: 114,
    flex: 0.8,
    renderCell: ({ row }) => <ProductCell product={row.silobag_product_types} />,
  };
}

function ProductCell({ product }: { product?: { name: string } | null }) {
  const name = product?.name?.trim() || FALLBACK_STRING;

  return (
    <Stack height="100%" width="100%" direction="row" alignItems="center" sx={{ minWidth: 0, px: 1 }}>
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography
          noWrap
          title={name}
          sx={{
            fontSize: 13,
            fontWeight: 600,
            color: '#3A3440',
            lineHeight: 1.25,
            letterSpacing: '0.01em',
          }}
        >
          {name}
        </Typography>
      </Box>
    </Stack>
  );
}
